import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/news",
    name: "News",
    component: () => import("../views/News.vue")
  },
  {
    path: "/course",
    name: "Course",
    component: () => import("../views/Course.vue")
  },
  {
    path: "/award",
    name: "Award",
    component: () => import("../views/Award.vue")
  },
  {
    path: "/activity",
    name: "Activity",
    component: () => import("../views/Activity.vue")
  },
  {
    path: "/media",
    name: "Media",
    component: () => import("../views/Media.vue")
  },
  {
    path: "/document",
    name: "Document",
    component: () => import("../views/Document.vue")
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
